<template>
  <div class="step d-f ai-c jc-sb">
    <div class="minus item d-f ai-c jc-c" :class="{ disable: min === value }" @click.stop="minus">-</div>
    <div class="d-f ai-c jc-c">{{ value }}</div>
    <div class="plus item d-f ai-c jc-c" :class="{ disable: max === value }" @click.stop="plus">+</div>
  </div>
</template>

<script>
import { create } from '../utils'

export default create({
  name: 'step',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: Infinity
    }
  },
  methods: {
    minus() {
      if (this.min === this.value) {
        return
      } else {
        this.$emit('change', this.value - 1)
      }
    },
    plus() {
      if (this.max === this.value) {
        return
      } else {
        this.$emit('change', this.value + 1)
      }
    }
  }
})
</script>

<style lang="scss">
.step {
  border: 2px solid #dcdcdc;
  border-radius: 8px;
  min-width: 216px;
  font-size: 36px;
  .item {
    height: 70px;
    width: 70px;
    &.disable {
      color: #e3e3e3;
    }
  }
}
</style>
